/** Payment functions **/
import {endpoints} from "@/api/endpoints";
import {authenticatedRequestBody} from "@/api/services/auth";


export const getCustomerPortal = async (): Promise<string> => {
  try {
    const session_data = await authenticatedRequestBody(null);

    const response = await fetch(endpoints.customer_portal, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: session_data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Check for error in response data
    if (data.error) {
      throw new Error(data.error);
    }

    return data.url;
  } catch (error) {
    //console.error('Customer portal error:', error);
    
    // Check if it's a Stripe customer error (special free subscription)
    if (error instanceof Error && error.message.includes('No such customer')) {
      throw new Error('Billing information not found. You may have a special subscription that does not require billing details. If you need assistance, please contact support@nestrr.net.');
    }
    
    // For other errors, throw a generic message

    throw new Error('Billing information not found. If you need assistance, please contact support@nestrr.net.');
    //throw new Error('Unable to access billing portal. Please try again or contact support@nestrr.net.');
  }
}


/**
 * Post an authenticated request to the checkout endpoint to get the checkout URL to redirect to.
 *
 * This is used to get the checkout URL to redirect to for payment.
 */
export const getPaymentRedirect = async (): Promise<string> => {
  const session_data = await authenticatedRequestBody(null);

  const response = await fetch(endpoints.subscribe, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: session_data,
  });

  const data = await response.json();
  return data.url
}